module.exports = __webpack_public_path__ + "static/media/MHRP09N0007.4e9564b9.svg";